<template>
    <a-modal
        :width="'45%'"
        v-model="updateGroup"
        title="修改分组"
        :maskClosable="maskClosable"
        @ok="handleOk">
        <div>
            <a-form :form="form">
                <a-form-item label='所属机构' v-bind="formItemLayout">
                    <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                </a-form-item>

                <a-form-item label='所属分组' v-bind="formItemLayout">
                    <a-select  v-model="groupId" size="small" v-decorator="['groupId',{ rules: [{ required: true, message: '所属分组不能为空!' }] }] ">
                        <a-select-option v-for="group in groups" :key="group.groupId" >{{group.groupName}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    export default {
        name: 'ZUpdateOrgGroup',
        data() {
            return {
                updateGroup: false,
                maskClosable: false,
                groups: [],
                groupId: null,
                orgId: null,
                entityIds: [],
                form: null,
                orgOption:{
                    id: "updateOrgGroup",
                    value: ""
                },
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    },
                }
            }
        },
        components:{
            ZOrgChooser
        },
        methods:{
            onOrgSelect(org){
                this.orgId = org.id
                this.$http.get(config.api.entity_group_summary_url + '/' + org.id).then((response) => {
                    if(response.code == 0){
                        this.groups = response.result
                        this.groupId = org.defaultEntityGroupId
                        this.form.setFieldsValue({
                            groupId: org.defaultEntityGroupId
                        });
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            handleOk() {
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        this.$http.put(config.api.entity_url + "/group/" + this.groupId + "/org/" + this.orgId, this.entityIds).then((response) => {
                            if(response.code == 0){
                                this.updateGroup = false
                                this.$message.success('修改成功')
                                this.$emit('success');
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                })
            },
            showModel(groups,org,entityIds){
                this.updateGroup = true
                this.entityIds = entityIds
                this.form = this.$form.createForm(this)
                if(this.$refs["orgChooser"]){
                    this.$refs["orgChooser"].initOrgTree()
                }
            }
        }
    }
</script>